module.exports = __webpack_public_path__ + "static/media/color_reframe_red.24219659.jpeg";